'use client'

import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts'
import type { AreaPayload } from '../svs-types'
import { resolveColor } from '../color-mapping'

interface AreaRendererProps {
  payload: AreaPayload
}

export function AreaRenderer({ payload }: AreaRendererProps) {
  const { categories, series } = payload.data
  const options = payload.options || {}
  const showLegend = series.length > 1

  const data = categories.map((cat, i) => {
    const point: Record<string, unknown> = { name: cat }
    series.forEach((s, si) => {
      point[s.name || `series-${si}`] = s.values[i]
    })
    return point
  })

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 10, right: 20, left: 10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis dataKey="name" label={options.xLabel ? { value: options.xLabel, position: 'insideBottom', offset: -5 } : undefined} />
        <YAxis label={options.yLabel ? { value: options.yLabel, angle: -90, position: 'insideLeft' } : undefined} />
        <Tooltip />
        {showLegend && <Legend />}
        {series.map((s, si) => {
          const key = s.name || `series-${si}`
          const color = resolveColor(s.color, si)
          return (
            <Area
              key={key}
              type={options.smooth ? 'monotone' : 'linear'}
              dataKey={key}
              stroke={color}
              fill={color}
              fillOpacity={0.2}
              strokeWidth={2}
              stackId={options.stacked ? 'stack' : undefined}
              dot={options.showPoints || false}
              connectNulls={false}
            />
          )
        })}
      </AreaChart>
    </ResponsiveContainer>
  )
}
